<div class="text-center py-5">
  <!-- <i class="fas fa-circle-notch fa-spin"></i> -->
  <mat-spinner [diameter]="50" class="mx-auto"></mat-spinner>
</div>
